<template>
    <div
        class="container weflix-admin-newVideo page-card w-100 edit-video-page"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="edit-video-header">
            <div class="edit-video-header__lead">
                <TitlePage
                    title="Novo Vídeo"
                    subtitle="Crie um novo vídeo para sua coleção"
                    :hasMargin="false"
                />
            </div>
        </header>

        <div class="edit-video-shell" v-if="hasReady">
            <main class="edit-video-main">
                <section class="edit-video-panel edit-video-panel--form">
                    <h4 class="edit-video-panel__title">Dados do vídeo</h4>
                    <div class="edit-video-grid-2">
                        <div class="form-group">
                            <div class="form-label">
                                <label>Status</label>
                            </div>
                            <div class="form-input">
                                <select class="form-control" v-model="status">
                                    <option :value="true">Ativado</option>
                                    <option :value="false">Desativado</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-label">
                                <label>Visibilidade</label>
                            </div>
                            <div class="form-input">
                                <select class="form-control" v-model="sample">
                                    <option :value="true">Gratuito</option>
                                    <option :value="false">Pago</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="form-label">
                            <label>Título do vídeo</label>
                        </div>
                        <div class="form-input">
                            <input
                                type="text"
                                required
                                class="form-control"
                                v-model="name"
                                placeholder="Título exibido na coleção"
                            />
                        </div>
                    </div>
                    <div class="form-group edit-video-description">
                        <div class="form-label">
                            <label>Descrição do vídeo</label>
                        </div>
                        <div class="form-textarea edit-video-description__field">
                            <textarea
                                class="form-control"
                                v-model="longDescription"
                                maxlength="300"
                                placeholder="Descrição do vídeo"
                            ></textarea>
                        </div>
                        <small class="char-counter"
                            >{{ (longDescription || '').length }}/300 caracteres</small
                        >
                    </div>
                </section>
            </main>

            <aside class="edit-video-aside">
                <section class="edit-video-panel edit-video-panel--media">
                    <h4 class="edit-video-panel__title">Pré-visualização</h4>
                    <div class="edit-video-file-upload">
                        <VideoUploadInput
                            label="Arquivo do vídeo"
                            :preview-url="path"
                            accept=".mp4, .mov, .webm, .avi"
                            accept-text="Envie o arquivo e salve para o player ficar disponível"
                            placeholder="Clique para enviar o vídeo"
                            @file-selected="handleVideoSelected"
                            @remove-preview="handleVideoRemove"
                            :uploading="isUploading"
                            :progress="progress"
                        />
                    </div>
                    <div class="edit-video-upload-wrap image-upload-input">
                        <div class="form-label">
                            <label>Capa do vídeo</label>
                        </div>
                        <div class="image-preview-wrapper" v-if="previewCoverVideo">
                            <div class="image-preview-container">
                                <img
                                    :src="previewCoverVideo"
                                    alt="Preview da capa"
                                    class="image-preview"
                                />
                                <div class="image-overlay">
                                    <fa icon="fa-circle-play" />
                                </div>
                            </div>
                        </div>
                        <p v-if="previewCoverVideo" class="cover-edit-hint">
                            Esta capa poderá ser editada na edição do vídeo.
                        </p>
                        <div class="upload-container" v-if="!previewCoverVideo">
                            <div class="file-wrapper">
                                <div class="file-label" style="cursor: default;">
                                    <div class="upload-icon">
                                        <fa icon="fa-image" />
                                    </div>
                                    <div class="upload-text">
                                        <span class="upload-title">A capa será gerada automaticamente do vídeo</span>
                                        <span class="upload-subtitle">Pode ser substituída posteriormente editando o vídeo</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <video
                        ref="hiddenVideo"
                        style="display: none;"
                        @loadedmetadata="onVideoLoaded"
                        @seeked="onVideoSeeked"
                    ></video>
                    <canvas ref="thumbnailCanvas" style="display: none;"></canvas>
                </section>
            </aside>
        </div>

        <footer class="edit-video-footer">
            <v-btn
                variant="outlined"
                color="primary"
                size="large"
                border="2"
                class="text-none"
                @click="() => $router.push('/admin/colecao/' + currentCollections.id)"
            >Voltar</v-btn>
            <v-btn
                variant="flat"
                color="primary"
                size="large"
                class="text-none"
                :disabled="!loaderImage || (Boolean(path) && !coverVideo)"
                :class="{ disabled: !loaderImage }"
                @click="newVideo()"
            >Salvar</v-btn>
        </footer>
    </div>
    <div class="pa-4 text-center" style="padding: 0px!important;">
        <v-dialog
            v-model="deleteItem"
            max-width="320"
            persistent
        >
            <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>
                    Deseja realmente excluir o vídeo {{ nameItem }}?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="cancel" text @click="closeDialog">Não</v-btn>
                    <v-btn class="accept" text @click="closeDialog">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <v-dialog v-model="showCopyDialog" class="copy-video-dialog" max-width="600">
        <v-card>
            <v-card-title>Copiar Vídeo</v-card-title>
            <v-card-text>
                <div class="move-controls">
                    <p>Selecione a coleção de origem</p>
                    <select v-model="selectedCollection" class="form-select" @change="putIdReuseVideoCollection()"> 
                        <option value="">Selecione uma coleção</option>
                        <option v-for="collection in collections" 
                                :key="collection.id"
                                :value="collection.id">
                            {{ collection.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-text>
                <div class="move-controls">
                    <p>Selecione o vídeo</p>
                    <select v-model="selectedLesson" class="form-select"
                    @change="getVideoById()"
                    >
                        <option value="">Selecione um vídeo</option>
                        <option v-for="videos in lessonByCollection" 
                                :key="videos.id"
                                :value="videos.id">
                            {{ videos.name }}
                        </option>
                    </select>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="showCopyDialog = false">Cancelar</v-btn>
                <v-btn color="primary" text @click="copyVideo">Copiar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <Loader :hasReady="hasReady"/>
</template>

<script>
import Sesson from '@/utils/Weflix/sesson';
import Videos from '@/utils/Weflix/videos';
import apiAWS from '@/utils/storage/aws';
import companyApi from '@/utils/Weflix/company';
import Loader from '@/components/Weflix/Loader.vue';
import LoaderImage from '@/components/Weflix/LoaderImage';
import VideoUploadInput from '@/components/Weflix/VideoUploadInput.vue';
import TitlePage from '@/components/Weflix/titlePage.vue';
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';

function emptyVideotecaUpload() {
    return {
        fileId: null,
        callbackUrl: null,
        uploadId: null,
        partUrls: [],
        partSize: 0,
        partCount: 0,
        fileUploadUrl: null,
        thumbnailUploadUrl: null,
        file: null,
        filename: null,
        mediaType: null,
        size: 0,
        parts: [],
        thumbnailUploaded: false,
    };
}

export default {
    data(){
        return{
            deleteItem: false,
            season:'',
            seasonSelected: null,
            noSeason: true,
            status: false,
            sample: false,
            name: '',
            longDescription: '',
            videoFile: null,
            coverVideo: '',
            previewCoverVideo:'',
            linkVideo: '',
            hasReady: true,
            loaderImage: true,
            tokenVideo: null,
            isUploading: false,
            isUploaded: false,
            progress: 0,
            showCopyDialog: false,
            selectedCollection: '',
            selectedLesson: '',
            collections: [],
            lessonByCollection: [],
            idReuseVideoCollection: null,
            path: null,
            activeUploads: [],
            uploadIdCounter: 0,
            videoObjectUrl: null,
            videotecaUpload: emptyVideotecaUpload(),
            videotecaFolderId: null,
            pendingCoverFile: null,
            canvasCoverFile: null,
        }
    },
    computed: {
        ...mapState(['token', 'currentCollections']),
    },
    components: {
        Loader,
        LoaderImage,
        VideoUploadInput,
        TitlePage
    },
    methods: {
        closeDialog(){
            this.deleteItem = false;
        },
        updateContentLongDescription(content) {
            this.longDescription = content;
        },
        async getVideoById(){
            const response = await Videos.getVideosById(this.token, this.selectedLesson);
            this.name = response.title || '';
            this.longDescription = response.description || '';
            this.coverVideo = response.videoThumbnail || '';
            this.previewCoverVideo = response.finalVideoThumbnail || '';
            this.sample = response.sample == 1 ? true : false;
            this.status = response.status == 1 ? true : false;
            this.path = response.path || '';
           
        },
        async copyVideo(){
            this.showCopyDialog = false;
        },
        async getSesson(){
            try {
                const response = await Sesson.getSessonByCollection(this.token, this.currentCollections.id);
                if(response.length > 0) {
                    if (Array.isArray(response)) {
                        this.season = response.sort((a, b) => a.order - b.order);
                        this.seasonSelected = this.season[0].id;
                        this.noSeason = false;
                    } else {
                        this.season = response;
                        this.seasonSelected = this.season[0].id;
                        this.noSeason = false;
                    }
                }
                else {
                    this.noSeason = true;
                    this.newSeason();
                }
            } catch (error) {
                console.error('Erro ao obter dados da coleção:', error);
            }
        },
        async newSeason(){
            const payload = {
                "course": {
                    "id": this.currentCollections.id
                },
                "title": "Temporada 1",
                "sample": 0
            }
            try {
                const response = await Sesson.createSesson(this.token, payload);
                this.noSeason = false;
                this.getSesson();
            } catch (error) {
                console.error('Erro ao criar temporada:', error);
            }
        },     
        async putFileAws(url, file){
            await apiAWS.putFileAWS(url, file);
        },
        handleVideoSelected(file, event) {
            this.uploadVideoAws(event);
            // Capturar frame do vídeo em 0.5s
            this.captureVideoThumbnail(file);
        },
        handleVideoRemove() {
            if (this.path) {
                URL.revokeObjectURL(this.path);
                this.path = null;
                this.videoFile = null;
            }
            this.progress = 0;
            this.isUploading = false;
            // Limpar também a capa quando o vídeo for removido
            this.handleImageRemove();
        },
        handleImageRemove() {
            if (this.previewCoverVideo) {
                URL.revokeObjectURL(this.previewCoverVideo);
                this.previewCoverVideo = '';
                this.coverVideo = '';
            }
        },
        captureVideoThumbnail(file) {
            if (!file) return;
            
            this.loaderImage = false;
            const video = this.$refs.hiddenVideo;
            const canvas = this.$refs.thumbnailCanvas;
            
            if (!video || !canvas) {
                console.error('Elementos de vídeo ou canvas não encontrados');
                this.loaderImage = true;
                return;
            }
            
            // Limpar URL anterior se existir
            if (this.videoObjectUrl) {
                URL.revokeObjectURL(this.videoObjectUrl);
                this.videoObjectUrl = null;
            }
            
            // Criar URL do vídeo
            const videoUrl = URL.createObjectURL(file);
            video.src = videoUrl;
            this.videoObjectUrl = videoUrl;
            
            // Adicionar tratamento de erro
            video.onerror = () => {
                console.error('Erro ao carregar vídeo para captura de thumbnail');
                this.loaderImage = true;
                if (this.videoObjectUrl) {
                    URL.revokeObjectURL(this.videoObjectUrl);
                    this.videoObjectUrl = null;
                }
            };
        },
        onVideoLoaded() {
            const video = this.$refs.hiddenVideo;
            if (!video) return;
            
            // Verificar se o vídeo tem duração válida
            if (video.duration && video.duration > 0) {
                // Pular para 0.5 segundos (ou início se o vídeo for menor)
                video.currentTime = Math.min(0.5, video.duration - 0.1);
            } else {
                // Se não conseguir obter a duração, tentar mesmo assim
                video.currentTime = 0.5;
            }
        },
        async onVideoSeeked() {
            const video = this.$refs.hiddenVideo;
            const canvas = this.$refs.thumbnailCanvas;
            
            if (!video || !canvas) {
                console.error('Elementos de vídeo ou canvas não encontrados');
                this.loaderImage = true;
                return;
            }
            
            // Verificar se o vídeo tem dimensões válidas
            if (!video.videoWidth || !video.videoHeight) {
                console.error('Vídeo não possui dimensões válidas');
                this.loaderImage = true;
                return;
            }
            
            try {
                // Configurar dimensões do canvas
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                
                // Desenhar frame do vídeo no canvas
                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                
                // Converter canvas para blob
                canvas.toBlob(async (blob) => {
                    if (!blob) {
                        console.error('Erro ao gerar thumbnail do vídeo');
                        this.loaderImage = true;
                        return;
                    }
                    
                    // Limpar preview anterior se existir
                    if (this.previewCoverVideo) {
                        URL.revokeObjectURL(this.previewCoverVideo);
                    }
                    
                    // Criar preview
                    this.previewCoverVideo = URL.createObjectURL(blob);
                    
                    // Criar arquivo a partir do blob para upload
                    const file = new File([blob], 'thumbnail.jpg', { type: 'image/jpeg' });
                    this.canvasCoverFile = file;
                    
                    // Fazer upload da imagem
                    try {
                        await this.uploadCoverFile(file);
                        this.loaderImage = true;
                    } catch (error) {
                        console.error('Erro ao enviar capa para a Videoteca', error);
                        this.coverVideo = '';
                        this.loaderImage = false;
                        this.notify('Não foi possível enviar a capa gerada do vídeo.', 'error');
                    }
                }, 'image/jpeg', 0.95);
                
            } catch (error) {
                console.error('Erro ao capturar thumbnail do vídeo:', error);
                this.loaderImage = true;
            }
        },
        async ensureVideotecaFolderId() {
            if (this.videotecaFolderId) return this.videotecaFolderId;
            const status = await companyApi.getVideoteca(this.token);
            const folderId = status?.folderId || status?.idFolder || status?.idFolderVideoteca || null;
            if (!folderId) throw new Error('VIDEOTECA_FOLDER_MISSING');
            this.videotecaFolderId = String(folderId);
            return this.videotecaFolderId;
        },
        async uploadCoverFile(file) {
            const response = await apiAWS.getSignatureImage(this.token, file.name || 'thumbnail.jpg');
            const token = response?.token;
            if (!response?.url || !token) {
                throw new Error('Assinatura da capa sem token');
            }
            await this.putFileAws(response.url, file);
            this.coverVideo = token;

            const thumbUrl = this.videotecaUpload?.thumbnailUploadUrl;
            if (!thumbUrl) {
                this.pendingCoverFile = file;
                return token;
            }
            await this.putFileAws(thumbUrl, file);
            this.videotecaUpload.thumbnailUploaded = true;
            this.pendingCoverFile = null;
            return token;
        },
        async flushPendingCover() {
            const file = this.pendingCoverFile;
            const thumbUrl = this.videotecaUpload?.thumbnailUploadUrl;
            if (!file || !thumbUrl) return;
            await this.putFileAws(thumbUrl, file);
            this.videotecaUpload.thumbnailUploaded = true;
            this.pendingCoverFile = null;
        },
        async uploadVideoAws(event) {
            const localUploadId = ++this.uploadIdCounter;
            try {
                const file = event.target.files[0];
                if (!file) return;

                if (Math.round(file.size / (1024 * 1024)) > 4096) {
                    this.notify('O arquivo passa de 4 GB.', 'error');
                    return;
                }

                this.activeUploads.push({
                    id: localUploadId,
                    filename: file.name,
                    fileSize: file.size,
                    progress: 0,
                    speed: 0,
                    isUploading: false,
                    isCompleted: false,
                    error: null,
                    startTime: null,
                    lastProgressTime: null,
                    lastProgressBytes: 0,
                });

                this.path = URL.createObjectURL(file);
                this.videoFile = file;
                this.videotecaUpload = emptyVideotecaUpload();
                this.isUploaded = false;
                this.progress = 0;

                const folderId = await this.ensureVideotecaFolderId();
                const title = (this.name || '').trim() || file.name.replace(/\.[^.]+$/, '') || file.name;
                const initResponse = await apiAWS.initVideotecaUpload(this.token, {
                    filename: file.name,
                    mediaType: file.type || 'video/mp4',
                    folderId,
                    title,
                    size: file.size,
                    metadata: {},
                });
                if (!initResponse) throw new Error('URLs de upload inválidas');

                const data = initResponse.data || initResponse;
                const multipart = data.multipart || null;
                const partUrls = Array.isArray(multipart?.partUrls)
                    ? [...multipart.partUrls].sort((a, b) => Number(a.partNumber) - Number(b.partNumber))
                    : [];
                const uploadId = multipart?.uploadId || data.uploadId || initResponse.uploadId || null;
                if (partUrls.length > 0 && !uploadId) {
                    throw new Error('Init multipart sem uploadId — não é possível finalizar o upload.');
                }

                this.videotecaUpload = {
                    ...emptyVideotecaUpload(),
                    fileId: data.fileId || null,
                    callbackUrl: data.callbackUrl || null,
                    uploadId,
                    partUrls,
                    partSize: Number(multipart?.partSize) || 0,
                    partCount: Number(multipart?.partCount) || partUrls.length || 0,
                    fileUploadUrl: data.fileUploadUrl || null,
                    thumbnailUploadUrl: data.thumbnailUploadUrl || null,
                    file,
                    filename: file.name,
                    mediaType: file.type || 'video/mp4',
                    size: file.size,
                };
                this.tokenVideo = {
                    uploadId,
                    urls: partUrls.map((part) => ({ url: part.url, token: null, partNumber: part.partNumber })),
                };
                await this.flushPendingCover();
                await this.putVideoAwsV1(this.videotecaUpload, localUploadId);
            } catch (error) {
                console.error('Erro ao enviar arquivo para a Videoteca', error);
                const uploadIndex = this.activeUploads.findIndex((u) => u.id === localUploadId);
                if (uploadIndex !== -1) {
                    this.activeUploads[uploadIndex].error = error?.message === 'VIDEOTECA_FOLDER_MISSING'
                        ? 'A empresa não tem pasta na Videoteca.'
                        : (error.message || 'Erro no upload');
                    this.activeUploads[uploadIndex].isUploading = false;
                }
                if (error?.message === 'VIDEOTECA_FOLDER_MISSING') {
                    this.notify('A empresa não tem pasta na Videoteca.', 'error');
                }
                this.videotecaUpload = emptyVideotecaUpload();
                this.isUploading = false;
                this.isUploaded = false;
            }
        },
        async putVideoAwsV1(uploadState, localUploadId) {
            const uploadIndex = this.activeUploads.findIndex((u) => u.id === localUploadId);
            const uploadEntry = uploadIndex === -1 ? null : this.activeUploads[uploadIndex];
            const file = uploadState.file;
            if (!file) throw new Error('URLs de upload inválidas');

            if (uploadEntry) {
                uploadEntry.isUploading = true;
                uploadEntry.startTime = Date.now();
                uploadEntry.lastProgressTime = Date.now();
                uploadEntry.lastProgressBytes = 0;
            }
            this.isUploading = true;
            this.isUploaded = false;

            const partUrls = uploadState.partUrls || [];
            const parts = [];

            if (partUrls.length > 0) {
                const partSize = Number(uploadState.partSize) || Math.ceil(file.size / partUrls.length);
                const progressArray = new Array(partUrls.length).fill(0);
                for (let i = 0; i < partUrls.length; i += 1) {
                    const part = partUrls[i];
                    const partNumber = Number(part.partNumber) || (i + 1);
                    const start = i * partSize;
                    const end = Math.min(start + partSize, file.size);
                    const chunk = file.slice(start, end);
                    const response = await apiAWS.putVideoAWS(part.url, chunk, (progress) => {
                        progressArray[i] = progress;
                        const totalProgress = progressArray.reduce((a, b) => a + b, 0) / partUrls.length;
                        this.progress = totalProgress;
                        if (uploadEntry) uploadEntry.progress = totalProgress;
                    });
                    if (!response?.etag) throw new Error(`ETag ausente na parte ${partNumber}`);
                    parts.push({ partNumber, etag: response.etag });
                }
            } else if (uploadState.fileUploadUrl) {
                await apiAWS.putVideoAWS(uploadState.fileUploadUrl, file, (progress) => {
                    this.progress = progress;
                    if (uploadEntry) uploadEntry.progress = progress;
                });
            } else {
                throw new Error('URLs de upload inválidas');
            }

            this.videotecaUpload = {
                ...this.videotecaUpload,
                parts: uploadState.uploadId ? parts : [],
            };
            this.isUploaded = true;
            this.isUploading = false;
            this.progress = 100;
            if (uploadEntry) {
                uploadEntry.isCompleted = true;
                uploadEntry.isUploading = false;
                uploadEntry.progress = 100;
                uploadEntry.speed = 0;
                setTimeout(() => {
                    const index = this.activeUploads.findIndex((u) => u.id === localUploadId);
                    if (index !== -1) this.activeUploads.splice(index, 1);
                }, 3000);
            }
        },
        handleCancelUpload(uploadId) {
            const uploadIndex = this.activeUploads.findIndex(u => u.id === uploadId);
            if (uploadIndex !== -1) {
                this.activeUploads[uploadIndex].isUploading = false;
                this.activeUploads[uploadIndex].error = 'Upload cancelado pelo usuário';
                
                // Limpar preview se for o upload atual
                if (this.activeUploads[uploadIndex].id === this.uploadIdCounter) {
                    if (this.path) {
                        URL.revokeObjectURL(this.path);
                        this.path = null;
                        this.videoFile = null;
                    }
                }
                
                // Remover após um tempo
                setTimeout(() => {
                    const index = this.activeUploads.findIndex(u => u.id === uploadId);
                    if (index !== -1) {
                        this.activeUploads.splice(index, 1);
                    }
                }, 2000);
            }
        },
        async getCollections(){
            try {
                const response = await Videos.listCollections(this.token);
                this.collections = response.map(item => ({
                    id: item.id,
                    name: item.name,
                    status: item.status
                }));
            } catch (error) {
                console.error('Erro ao obter coleções:', error);
            }
        },
        putIdReuseVideoCollection(){
            this.idReuseVideoCollection = this.selectedCollection;
            this.getLessonByCollections();
        },
        async getLessonByCollections(){
            try {
                const response = await Videos.listLessonByCollections(this.token, this.idReuseVideoCollection);
                this.lessonByCollection = response;
            } catch (error) {
                console.error('Erro ao obter aulas:', error);
            }
        },
        /** Corpo do POST /file/videoteca/upload: lesson direta ou dentro de data/body/result. */
        extractCreatedLessonId(created) {
            if (created == null) return null;
            if (typeof created === 'string') {
                const t = created.trim();
                if (!t) return null;
                if (t.startsWith('{') || t.startsWith('[')) {
                    try {
                        return this.extractCreatedLessonId(JSON.parse(t));
                    } catch {
                        return null;
                    }
                }
                return t;
            }
            if (typeof created !== 'object') return null;
            if (created.id != null && created.id !== '') {
                return String(created.id);
            }
            const nests = [
                created.data,
                created.body,
                created.result,
                created.payload,
                created.lesson,
                created.content,
            ];
            for (const n of nests) {
                if (n != null && typeof n === 'object' && !Array.isArray(n)) {
                    if (n.id != null && n.id !== '') return String(n.id);
                }
            }
            return null;
        },
        miniLessonsAsArray(mini) {
            if (Array.isArray(mini)) return mini;
            if (mini?.list != null) return mini.list;
            if (mini?.content != null) return mini.content;
            return [];
        },
        async resolveLessonIdAfterVideotecaCreate(createdPayload) {
            let id = this.extractCreatedLessonId(createdPayload);
            if (id) return id;
            const title = (this.name || '').trim();
            const pickByTitle = (list, titleKey = 'title') => {
                if (!list?.length) return null;
                const same = list.filter(
                    (v) => (v[titleKey] || v.name || '').trim() === title
                );
                const row =
                    same.length > 0 ? same[same.length - 1] : list[list.length - 1];
                return row?.id != null ? String(row.id) : null;
            };
            if (this.seasonSelected) {
                try {
                    const mod = await Videos.getVideosBySesson(
                        this.token,
                        this.seasonSelected
                    );
                    id = pickByTitle(mod?.list || [], 'title');
                    if (id) return id;
                } catch (e) {
                    console.error('Erro ao listar vídeos do módulo:', e);
                }
            }
            if (this.currentCollections?.id) {
                try {
                    const mini = await Videos.listLessonByCollections(
                        this.token,
                        this.currentCollections.id
                    );
                    const list = this.miniLessonsAsArray(mini);
                    id = pickByTitle(list, 'name');
                    if (id) return id;
                } catch (e) {
                    console.error('Erro ao listar aulas da coleção (mini):', e);
                }
            }
            return null;
        },
        async loadVideotecaStatus() {
            try {
                const status = await companyApi.getVideoteca(this.token);
                this.videotecaFolderId = status?.folderId || status?.idFolder || status?.idFolderVideoteca || null;
            } catch (error) {
                console.warn('Não foi possível carregar status da Videoteca:', error);
            }
        },
        async newVideo(){
            this.hasReady = false;

            let videoThumbnail = this.coverVideo || null;
            try {
                if (this.canvasCoverFile) {
                    videoThumbnail = await this.uploadCoverFile(this.canvasCoverFile);
                }
            } catch (error) {
                console.error('Erro ao enviar a capa do vídeo', error);
                this.notify('Não foi possível enviar a capa gerada do vídeo.', 'error');
                this.hasReady = true;
                return;
            }
            if ((this.path || this.canvasCoverFile) && !videoThumbnail) {
                this.notify('A capa gerada do vídeo não foi enviada.', 'error');
                this.hasReady = true;
                return;
            }

            const upload = this.videotecaUpload || {};
            const parts = Array.isArray(upload.parts) && upload.parts.length ? upload.parts : null;
            const payload = {
                type: 6,
                title: this.name,
                description: this.longDescription,
                idModule: this.seasonSelected,
                status: this.status === true ? 1 : 0,
                sample: this.sample === true ? 1 : 0,
                favourite: null,
                fileId: upload.fileId || null,
                callbackUrl: upload.callbackUrl || null,
                filename: upload.filename || null,
                mediaType: upload.mediaType || null,
                size: upload.size || null,
                thumbnailUploaded: Boolean(upload.thumbnailUploaded),
                path: null,
                youtubeUrl: null,
                videoThumbnail,
                token: null,
            };
            if (upload.uploadId && parts) {
                payload.uploadId = upload.uploadId;
                payload.parts = parts;
            }

            try {
                const created = await apiAWS.createVideoVideoteca(
                    this.token,
                    payload
                );
                let lessonId = this.extractCreatedLessonId(created);
                if (!lessonId) {
                    lessonId = await this.resolveLessonIdAfterVideotecaCreate(
                        created
                    );
                }
                if (lessonId != null && lessonId !== '') {
                    await this.$router.replace({
                        path: `/admin/video/${encodeURIComponent(lessonId)}`,
                    });
                } else {
                    this.notify(
                        'Vídeo criado, mas não foi possível abrir a edição. Abra-o na lista da coleção.',
                        'warning'
                    );
                    await this.$router.replace(
                        '/admin/colecao/' + this.currentCollections.id
                    );
                }
            } catch (error) {
                console.error('Erro ao enviar arquivo para AWS', error);
                this.notify(
                    'Erro ao criar o vídeo. Tente novamente.',
                    'error'
                );
            } finally {
                this.hasReady = true;
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    },  
    created(){
        this.getSesson();
        this.getCollections();
        this.loadVideotecaStatus();
    },
    beforeUnmount() {
        // Limpar URLs criadas
        if (this.videoObjectUrl) {
            URL.revokeObjectURL(this.videoObjectUrl);
        }
        if (this.path) {
            URL.revokeObjectURL(this.path);
        }
        if (this.previewCoverVideo) {
            URL.revokeObjectURL(this.previewCoverVideo);
        }
    }
}
</script>

<style>
@import url(./global.css);
@import url(@/css/weflix/admin/newVideo.css);

.uploadVideoBox {
    border: none !important;
    padding: 0px !important;
}

.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #150065;
    font-weight: 500;
}

.loading-spinner svg {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.upload-complete {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #28a745;
    font-weight: 500;
}

.upload-complete svg {
    color: #28a745 !important;
}

/* Estilos para o componente de capa gerada do vídeo */
.image-upload-input {
    width: 100%;
    margin-top: 1.5rem;
}

.image-preview-wrapper {
    margin-bottom: 1rem;
}

.image-preview-container {
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    padding: 8px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
}

.image-preview {
    width: auto;
    height: auto;
    max-height: 200px;
    object-fit: cover;
    border-radius: 8px;
    display: block;
    margin: 0 auto;
}

.remove-preview-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    transition: all 0.2s ease;
    z-index: 10;
}

.remove-preview-btn:hover {
    background: rgba(220, 53, 69, 0.9);
    transform: scale(1.1);
}

.image-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 3rem;
    opacity: 0.9;
    pointer-events: none;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    z-index: 5;
}

.upload-container {
    width: 100%;
}

.file-wrapper {
    position: relative;
    width: 100%;
}

.file-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2.5rem 1.5rem;
    border: 1px solid #e5e7eb !important;
    border-style: solid !important;
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.2s ease;
    text-align: center;
    min-height: 180px;
    height: 180px;
}

.upload-icon {
    margin-bottom: 1rem;
    color: #150065;
    font-size: 3rem;
    opacity: 0.8;
    transition: all 0.3s ease;
}

.upload-text {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.upload-title {
    font-weight: 600;
    color: #1a1a1a;
    font-size: 1rem;
}

.upload-subtitle {
    font-size: 0.75rem;
    color: #6b7280;
}

@media (max-width: 768px) {
    .file-label {
        padding: 2rem 1rem;
        min-height: 160px;
    }

    .upload-icon {
        font-size: 2.5rem;
    }

    .image-preview {
        max-height: 200px;
    }
}
</style>

<style scoped>
    .cover-edit-hint {
        margin: 0.75rem 0 0;
        color: #5c6370;
        font-size: 0.8125rem;
        text-align: center;
    }

    .edit-video-page.container.weflix-admin-newVideo.page-card.w-100 {
        width: 100%;
        max-width: 100%;
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1.5rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .edit-video-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem 1.5rem;
        padding: 1.25rem 1.5rem 1rem;
        background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
        border-bottom: 1px solid #e8eaf0;
        border-radius: 16px 16px 0 0;
    }

    .edit-video-header__lead {
        flex: 1;
        min-width: 200px;
    }

    .edit-video-shell {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 1.25rem;
        align-items: stretch;
        padding: 1.25rem 1.5rem 0;
    }

    @media (max-width: 991px) {
        .edit-video-shell {
            grid-template-columns: 1fr;
        }

        .edit-video-aside {
            order: -1;
        }
    }

    .edit-video-main,
    .edit-video-aside {
        display: flex;
        flex-direction: column;
        min-width: 0;
    }

    .edit-video-main {
        min-height: 100%;
    }

    .edit-video-aside .edit-video-panel--media {
        flex: 1;
    }

    .edit-video-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-video-panel--form {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
    }

    .edit-video-description {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        margin-bottom: 0 !important;
    }

    .edit-video-description__field {
        display: flex;
        flex: 1;
        min-height: 8rem;
    }

    .edit-video-description__field textarea {
        flex: 1;
        width: 100%;
        min-height: 8rem;
        resize: none;
    }

    .edit-video-description .char-counter {
        display: block;
        margin-top: 0.4rem;
        text-align: right;
    }

    .edit-video-panel__title {
        margin: 0 0 1rem;
        font-size: 0.8125rem;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #5c6370;
    }

    .edit-video-grid-2 {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem 1.25rem;
    }

    @media (max-width: 480px) {
        .edit-video-grid-2 {
            grid-template-columns: 1fr;
        }
    }

    .edit-video-panel .form-group {
        margin-bottom: 1.1rem;
    }

    .edit-video-panel .form-group:last-child {
        margin-bottom: 0;
    }

    .edit-video-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 0.75rem;
        margin-top: 1.5rem !important;
        padding: 1.25rem 1.5rem 0;
        border-top: 1px solid #e8eaf0;
    }

    .edit-video-upload-wrap {
        margin-top: 1rem;
    }

    .edit-video-file-upload :deep(.video-preview-container) {
        height: auto;
        aspect-ratio: 16 / 9;
    }

    .edit-video-file-upload :deep(.video-preview) {
        width: 100%;
        height: 100%;
        max-height: none;
        object-fit: contain;
    }

    @media (max-width: 991px) {
        .edit-video-panel--form {
            height: auto;
        }

        .edit-video-description__field,
        .edit-video-description__field textarea {
            flex: none;
            min-height: 8rem;
            height: 8rem;
        }
    }
</style>